// extracted by mini-css-extract-plugin
export default {"profileDashboard":"ProfileTab_profileDashboard__kwpCG","centerCol":"ProfileTab_centerCol__EggCi"};